module.exports = {
	"Play": "Lecture",
	"Pause": "Pause",
	"Current Time": "Temps actuel",
	"Duration Time": "Durée",
	"Remaining Time": "Temps restant",
	"Stream Type": "Type de flux",
	"LIVE": "EN DIRECT",
	"Loaded": "Chargé",
	"Progress": "Progression",
	"Fullscreen": "Plein écran",
	"Non-Fullscreen": "Fenêtré",
	"Mute": "Sourdine",
	"Unmute": "Son activé",
	"Playback Rate": "Vitesse de lecture",
	"Subtitles": "Sous-titres",
	"subtitles off": "Sous-titres désactivés",
	"Captions": "Sous-titres transcrits",
	"captions off": "Sous-titres transcrits désactivés",
	"Chapters": "Chapitres",
	"Close Modal Dialog": "Fermer la boîte de dialogue modale",
	"Descriptions": "Descriptions",
	"descriptions off": "descriptions désactivées",
	"Audio Track": "Piste audio",
	"You aborted the media playback": "Vous avez interrompu la lecture de la vidéo.",
	"A network error caused the media download to fail part-way.": "Une erreur de réseau a interrompu le téléchargement de la vidéo.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Cette vidéo n'a pas pu être chargée, soit parce que le serveur ou le réseau a échoué ou parce que le format n'est pas reconnu.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La lecture de la vidéo a été interrompue à cause d'un problème de corruption ou parce que la vidéo utilise des fonctionnalités non prises en charge par votre navigateur.",
	"No compatible source was found for this media.": "Aucune source compatible n'a été trouvée pour cette vidéo.",
	"The media is encrypted and we do not have the keys to decrypt it.": "Le média est chiffré et nous n'avons pas les clés pour le déchiffrer.",
	"Play Video": "Lire la vidéo",
	"Close": "Fermer",
	"Modal Window": "Fenêtre modale",
	"This is a modal window": "Ceci est une fenêtre modale",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Ce modal peut être fermé en appuyant sur la touche Échap ou activer le bouton de fermeture.",
	", opens captions settings dialog": ", ouvrir les paramètres des sous-titres transcrits",
	", opens subtitles settings dialog": ", ouvrir les paramètres des sous-titres",
	", opens descriptions settings dialog": ", ouvrir les paramètres des descriptions",
	", selected": ", sélectionné"
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/fr.json
// module id = 251
// module chunks = 81